import { enhanceEndDate } from "@/components/dynamic-form/formatter/enhanceEndTime";
import { DynamicForm } from "@/components/dynamic-form";
import { useDynamicForm } from "@/components/dynamic-form/hook/useDynamicForm";
import { useImmediateFetch } from "@/components/dynamic-form/hook/useImmediateFetch";
import { useWatchPagination } from "@/components/dynamic-form/hook/useWatchPagination";
import { useSearchConfig } from "./hooks/useFormConfig";
import styled from "styled-components";
import { TableContainer } from "@/components/table-container";
import { Table } from "@renderbus/ui";
import { useTranslation } from "react-i18next";
import { getInitialValues } from "@/components/dynamic-form/helper/getInitialValues";
import { Zone } from "project-config/constants";
import { useGlobalStore } from "@/store/GlobalStore";
import { useTableColumn } from "./hooks/useTableColumn";

export function InviteTable() {
  const { t } = useTranslation("center");
  const { userInfo, isPictureUser } = useGlobalStore();
  const { columns } = useTableColumn();
  const {
    form,
    tableData,
    fetchData,
    pageNum,
    setPageNum,
    pageSize,
    total,
    inviteNum,
    couponNum,
    earnVoucherNum,
  } = useDynamicForm({
    api: "/api/rendering/user/invite/getInviteList",
    defaultPageNum: 1,
    defaultPageSize: 5,
    formatter: {
      time: enhanceEndDate,
      taskType: (v) => (v === "All" ? undefined : v),
    },
    isInvite: true,
  });

  const fetch = (defaultPageNum?: number) =>
    fetchData({
      extraData: {
        pageNum: defaultPageNum || pageNum,
      },
    });

  useImmediateFetch(fetch);
  useWatchPagination(pageSize, pageNum, fetch);

  const { searchConfig } = useSearchConfig();

  return (
    <InviteRightContent>
      <TableContainer>
        <InviteTitle>{t("picture_rewards_get_title")}</InviteTitle>
        <InviteText>
          <span>
            {t("picture_rewards_success_pre")}&nbsp;
            <span className="num">{inviteNum}</span>&nbsp;
            {t("picture_rewards_success_suf")}
          </span>
          <span>
            {t("picture_rewards_rendering_pre")}&nbsp;
            <span className="num">
              {userInfo?.zone === Zone.Domestic ? "￥" : "$"}
              {couponNum}
            </span>
            &nbsp;
          </span>
          {isPictureUser && (
            <span>
              {t("picture_rewards_rendering_piece")}&nbsp;
              <span className="num">{earnVoucherNum}</span>&nbsp;
              {t("picture_rewards_rendering_piece_suf")}
            </span>
          )}
        </InviteText>
        <SearchContent>
          <InviteTitle style={{ display: "inline-block" }}>
            {t("picture_rewards_list")}
          </InviteTitle>
          <DynamicForm
            initialValues={getInitialValues(searchConfig)}
            searchConfig={searchConfig}
            searchForm={form}
            onSearch={() => fetch(1)}
            clearBtn
          />
        </SearchContent>
        <Table
          paginationCurrent={pageNum}
          columns={columns}
          dataSource={tableData}
          defaultPageSize={pageSize}
          total={total}
          gap={false}
          onPageNumChange={async (num) => {
            setPageNum(num);
          }}
        />
      </TableContainer>
    </InviteRightContent>
  );
}

export const SearchAreaWrapper = styled.div`
  display: flex;
  justify-content: space-between;
`;

const InviteRightContent = styled.div`
  /* width: 978px; */
  background-color: #292b2f;
  border-radius: 4px;
  flex: 1 1 0%;
`;

const InviteTitle = styled.div`
  display: flex;
  align-items: center;
  &::before {
    display: inline-block;
    content: "";
    width: 3px;
    height: 13px;
    margin-right: 8px;
    background: #13cb75;
  }
`;
const SearchContent = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
const InviteText = styled.div`
  display: flex;
  gap: 70px;
  color: #d9dfe0;
  align-items: center;
  .num {
    font-size: 36px;
    font-family: "DIN Alternate";
    font-weight: 700;
  }
`;
